import { Component, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'reactstrap';
import { Form } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';

import { AuthenticationContext } from '../../../msal/AuthenticationContext';
import { ButtonWithDisabledTooltip } from '../../../components/ButtonWithDisabledTooltip';

class ModalConnectionAddOrUpdateInternal extends Component {
    state = {
        connectionId: 0,
        name: "",
        clientId: "",
        clientSecret: "",
        hostname: "",
    }

    constructor(props) {
        super(props);

        // Build the name validation Regex.
        let nonPrintableCharStart = String.fromCharCode(0x00); // NULL char
        let nonPrintableCharEnd = String.fromCharCode(0x1F); // S7 char
        let delRegex = String.fromCharCode(0xF); // DEL char
        let backslashRegex = "\\\\"; // The parsing of the literal string will reduce this to 2 backslashes, the parsing of this string by the RegExp class will reduce it to a single literal backslash to be matched.
        let forwardslashRegex = "\\/"; 
        let bracketOpeningRegex = "\\["; 
        let bracketClosingRegex = "\\]"; 
        let quotationRegex = "\\\""; 
        let additionalCharsRegex = "!@#$%^&*()={};:";
        
        this.stringValidationRegex = new RegExp(`^[^${nonPrintableCharStart}-${nonPrintableCharEnd}${delRegex}${backslashRegex}${forwardslashRegex}${bracketOpeningRegex}${bracketClosingRegex}${quotationRegex}${additionalCharsRegex}]*$`);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen) {
            this.setInitialValues();
        }
    }

    setInitialValues = () => {
        const isUpdate = this.props.isUpdate;

        this.setState(
            {
                connectionId: isUpdate ? this.props.connectionToUpdate.id : "",
                name: isUpdate ? this.props.connectionToUpdate.name : "",
                clientId: isUpdate ? this.props.connectionToUpdate.clientId : "",
                clientSecret: "",
                hostname: isUpdate ? this.props.connectionToUpdate.hostname : "iqm.telecom-service.nl",
            }
        );
    }

    handleDoneButtonClicked = () => {
        const trimmedName = this.state.name.trim();
        const trimmedClientId = this.state.clientId.trim();

        const doneInfo = {
            id: this.state.connectionId,
            name: trimmedName,
            clientId: trimmedClientId,
            clientSecret: this.state.clientSecret,
            hostname: this.state.hostname,
            isUpdate: this.props.isUpdate
        }

        this.props.onAddOrUpdate(doneInfo);
    }

    handleNameChanged = (e) => {
        const updatedName = e.target.value;

        if (updatedName.length > 0 && !this.stringValidationRegex.test(updatedName)) {
            return;
        }
                
        this.setState({
            name: updatedName
        });
    }

    handleClientIdChanged = (e) => {
        const updatedClientId = e.target.value;

        if (updatedClientId.length > 0 && !this.stringValidationRegex.test(updatedClientId)) {
            return;
        }
                
        this.setState({
            clientId: updatedClientId
        });
    }

    handleClientSecretChanged = (e) => {
        const updatedClientSecret = e.target.value;
                
        this.setState({
            clientSecret: updatedClientSecret
        });
    }

    handleHostnameChanged = (e) => {
        const updatedHostname = e.target.value;

        if (updatedHostname.length > 0 && !this.stringValidationRegex.test(updatedHostname)) {
            return;
        }
                
        this.setState({
            hostname: updatedHostname
        });
    }

    shouldAddOrUpdateButtonBeEnabled = () => {
        return this.getAddOrUpdateButtonTooltip() === null;
    }

    getAddOrUpdateButtonTooltip = () => {
        if (!this.props.isOpen) {
            return null;
        }

        if (this.state.name === '') {
            return "Name may not be empty";
        }

        if (this.state.name.length > 36) {
            return "Name must be less than 36 characters";
        }

        if (this.state.clientId === '') {
            return "Client ID may not be empty";
        }

        if (this.state.clientId.length > 256) {
            return "Client ID must be less than 256 characters";
        }

        if (!this.props.isUpdate) {
            if (this.state.clientSecret === '') {
                return "Client secret may not be empty";
            }

            if (this.state.clientSecret.length > 256) {
                return "Client secret must be less than 256 characters";
            }

            return null;
        }

        if (this.props.isUpdate && this.state.clientSecret.length > 0) {
            return null;
        }

        if (this.state.hostname === '') {
            return "Hostname may not be empty";
        }

        if (this.state.hostname.length > 256) {
            return "Hostname must be less than 256 characters";
        }

        if (this.state.name !== this.props.connectionToUpdate.name ||
            this.state.clientId !== this.props.connectionToUpdate.clientId ||
            this.state.hostname !== this.props.connectionToUpdate.hostname) { 
                return null;
        }

        return "No changes detected";
    }

    render() {
        const headerText = this.props.isUpdate ? 'Update Connection' : 'Add Connection';
        const doneButtonText = this.props.isUpdate ? 'Update' : 'Add';
        const clientSecretPlaceholder = this.props.isUpdate ? '🞄🞄🞄🞄🞄🞄🞄🞄' : 'Enter client secret';

        return <Modal show={this.props.isOpen} onHide={this.props.onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{headerText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form className="mt-3" onSubmit={e => e.preventDefault()}>
                    <Form.Group controlId="newConnectionName">
                        <Form.Label>Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter name" value={this.state.name} autoComplete="off" onChange={this.handleNameChanged} />
                    </Form.Group>
                    <Form.Group controlId="newConnectionClientId">
                        <Form.Label>Client ID</Form.Label>
                        <Form.Control type="text" placeholder="Enter client ID" value={this.state.clientId} autoComplete="off" onChange={this.handleClientIdChanged} />
                    </Form.Group>
                    <Form.Group controlId="newConnectionClientSecret">
                        <Form.Label>Client secret</Form.Label>
                        <Form.Control type="password" placeholder={clientSecretPlaceholder} value={this.state.clientSecret} autoComplete="off" onChange={this.handleClientSecretChanged} />
                    </Form.Group>
                    <Form.Group controlId="newConnectionHostname">
                        <Form.Label>Hostname</Form.Label>
                        <Form.Control type="text" placeholder="Enter hostname" value={this.state.hostname} autoComplete="off" onChange={this.handleHostnameChanged} />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button color="secondary" onClick={this.props.onHide}>Cancel</Button>
                <ButtonWithDisabledTooltip color="primary" disabled={!this.shouldAddOrUpdateButtonBeEnabled()} disabledTooltip={this.getAddOrUpdateButtonTooltip()} onClick={this.handleDoneButtonClicked}>{doneButtonText}</ButtonWithDisabledTooltip>{' '}
            </Modal.Footer>
        </Modal>;
    }
}

export const ModalConnectionAddOrUpdate = (props) => {
    const authenticationContext = useContext(AuthenticationContext);  

    return (
        <ModalConnectionAddOrUpdateInternal authenticationContext={authenticationContext} {...props}/>
    )
}